import { PriorityBadgeController } from './priority-badge.controller'

const component = {
  templateUrl: '/core/components/priority-badge/priority-badge.html?$$REVISION$$',
  bindings: {
    priority: '<',
    variations: '@' // space-delimited
  },
  controllerAs: '$ctrl',
  controller: PriorityBadgeController
}

export const priorityBadge = component
